import api from '../callApi';
import { MonthDropdownValues } from '../../utils/enums';
import { parseAddressNumber, parseAddressStreet } from '../addressParser';

const apiCheckRegistrationStatus = (apiRequestData, values, actionCompletedTime) => {
    let utcStringDate = new Date(
        Date.UTC(
            parseInt(values.year, 10),
            MonthDropdownValues.indexOf(values.month),
            parseInt(values.day, 10)
        )
    ).toISOString();

    const request = {
        ...apiRequestData,
        email: values.email,
        firstName: values.firstName,
        lastName: values.lastName,
        street: parseAddressStreet(values.address),
        streetNo: parseAddressNumber(values.address),
        state: values.stateId,
        city: values.homeCity,
        subscribedToElectionReminders: values.getUpdates,
        dateOfBirth: utcStringDate,
        zipCode: values.postalCode,
        notifyResult: values.getUpdates,
        actionCompletedTime: actionCompletedTime
    };

    return api
        .post('Widget/CompleteCheckRegistrationAsync', request)
        .then(response => response);
};

export default apiCheckRegistrationStatus;



// WEBPACK FOOTER //
// ./src/utils/checkRegistration/apiCheckRegistrationStatus.js